document.addEventListener('DOMContentLoaded', function() {

    const videoPlayers = document.querySelectorAll('.block-video-custom');
    
    // Fonction pour générer un ID unique
    function generateUniqueId() {
        return 'player-' + Math.random().toString(36).substr(2, 9);
    }

    // Ajoute un écouteur d'événement à chaque élément '.block-video-custom'
    videoPlayers.forEach(videoPlayer => {
        videoPlayer.addEventListener("click", function(event) {
            console.log( this );
            const youtubeID = this.querySelector('.cta').getAttribute('data-youtube-id');
            if (typeof getCkyConsent === 'function' && getCkyConsent().categories.advertisement) {
                const uniqueId = generateUniqueId();
                this.innerHTML = '<div class="video__responsive content"><div id="' + uniqueId + '"></div></div>';

                // Crée le lecteur YouTube avec les paramètres définis
                new YT.Player(uniqueId, {
                    height: '1080',
                    width: '1920',
                    videoId: youtubeID,
                    host: 'https://www.youtube-nocookie.com',
                    playerVars: {
                        autoplay: 1,        // Auto-play the video on load
                        autohide: 1,
                        disablekb: 1,
                        controls: 1,        // Hide pause/play buttons in player
                        showinfo: 0,        // Hide the video title
                        modestbranding: 1,  // Hide the Youtube Logo
                        loop: 0,            // Run the video in a loop
                        fs: 0,              // Hide the full screen button
                        autohide: 1,        // Hide video controls when playing
                        rel: 0,
                        enablejsapi: 1
                    },
                    events: {
                        onReady: function(e) {
                            e.target.setPlaybackQuality('hd1080');
                            e.target.playVideo();
                        },
                        onStateChange: function(e) {
                            if (e && e.data === 0) {
                                // Video ended, replay
                                e.target.playVideo();
                            }
                        }
                    }
                });
            } else {
                displayPlaceholder(this, youtubeID);
            }
        });
    });

    function displayPlaceholder( el ) {
        el.classList.add('need-consent');
    }

    document.addEventListener('cookieyes_consent_update', function(eventData) {
        // Vérifier si "advertisement" est présent dans l'array accepted
        if (eventData.detail.accepted.includes('advertisement')) {
            location.reload();    
        }
    });
});

// Charger l'API YouTube Iframe
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);